module.exports = __webpack_public_path__ + "static/media/cypher.fcf9f81a.png";